import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.screens.confirmacaoSeguranca.background,
    alignItems: 'center',
  },
  containerGrid: {
    maxWidth: '402px',
    backgroundColor:
      theme.screens.confirmacaoSeguranca.containerGrid.background,
    padding: '40px',
    borderRadius: '8px',
    margin: '101px 0 80px',
    [theme.breakpoints.down('xs')]: {
      height: '623px',
      width: '414px',
      maxWidth: '100%',
      margin: 0,
      padding: '56px 21px 48px',
      borderRadius: '0px',
    },
  },

  link: {
    fontSize: '14px',
    fontWeight: 700,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '26px',
    letterSpacing: '-0.53px',
    textAlign: 'left',
    textDecoration: 'underline',
    color: theme.screens.confirmacaoSeguranca.link,
    fontFamily: theme.typography.bancoDoBrasilTextos.fontFamily,
    '&:hover': {
      filter: 'brightness(80%)',
    },
    cursor: 'pointer',
  },

  titulo: {
    padding: '24px 0px 8px',
    fontFamily: theme.typography.bancoDoBrasilTitulos.fontFamily,
    color: theme.screens.confirmacaoSeguranca.titulo,
    fontSize: 24,
    textAlign: 'left',
    fontWeight: 700,
  },
  subTitulo: {
    color: theme.appColors.darkGray,
    fontFamily: theme.typography.inter.fontFamily,
    fontSize: 14,
    letterSpacing: -0.01,
    textAlign: 'left',
    lineHeight: '24px',
  },

  button: {
    color: '#FFFFFF',
    fontFamily: 'BancoDoBrasilTitulos',
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.66px',
    textAlign: 'center',
    marginTop: theme.spacing(1),
    width: 200,
    height: '48px',
    marginBottom: 20,
    textTransform: 'uppercase',
    [theme.breakpoints.down('xs')]: {
      width: '90vw',
    },
  },
  input: {
    margin: '28px 0 38px',
  },
}));
